import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Timeline from 'react-visjs-timeline'
import { Loader, Container } from 'semantic-ui-react'
import vis from 'vis'
import { metaToTimeline } from 'utils/functions'
import css from './Timeline.module.sass'
import v4 from 'uuid/v4'

class MediaTimeline extends Component {
  constructor () {
    super(...arguments)

    this.onPlayerTimeUpdate = this.onPlayerTimeUpdate.bind(this)
    this.onTimeChangeHandler = this.onTimeChangeHandler.bind(this)
    this.onTimeChangedHandler = this.onTimeChangedHandler.bind(this)
    this.onActivateScissors = this.onActivateScissors.bind(this)
    this.onItemAdd = this.onItemAdd.bind(this)
    this.onItemMove = this.onItemMove.bind(this)
    this.onItemRemove = this.onItemRemove.bind(this)

    this.timelineElement = null
    this.timelineOptions = {
      showCurrentTime: false,
      verticalScroll: true,
      start: 0,
      end: this.props.playerElement.duration * 1000,
      min: 0,
      max: this.props.playerElement.duration * 1000,
      height: '150px',
      editable: {
        add: true,
        remove: true,
        updateGroup: false,
        updateTime: true,
        overrideItems: false
      },
      snap: null,
      type: 'range',
      moment: (date) => vis.moment(date).utc(),
      format: {
        majorLabels: {
          millisecond: 'HH:mm:ss',
          second: 'HH:mm:ss',
          minute: 'HH:mm:ss',
          hour: 'HH:mm:ss',
          weekday: 'HH:mm:ss',
          day: 'HH:mm:ss',
          week: 'HH:mm:ss',
          month: 'HH:mm:ss',
          year: 'HH:mm:ss'
        }
      },
      onAdd: this.onItemAdd,
      onMove: this.onItemMove,
      onRemove: this.onItemRemove
    }
    this.timelineGroups = [
      {
        id: 1,
        content: 'CUTS'
      }
    ]
    this.isChangingCustomTime = false
  }

  componentDidMount () {
    const { playerElement } = this.props

    setTimeout(() => {
      this.timelineElement.$el.addCustomTime(1, 1)

      playerElement.addEventListener('timeupdate', this.onPlayerTimeUpdate)

      this.addTimelineCustomHandlers()
    }, 100)
  }

  componentWillUnmount () {
    this.props.playerElement.removeEventListener('timeupdate', this.onPlayerTimeUpdate)
  }

  onPlayerTimeUpdate () {
    const { playerElement } = this.props

    if (!this.isChangingCustomTime) {
      this.timelineElement.$el.setCustomTime(playerElement.currentTime * 1000, 1)
    }
    // if (this.timeoutTimeUpdate) clearInterval(this.timeoutTimeUpdate)
    // this.timeoutTimeUpdate = setTimeout(() => {
    //   const filteredEvents = createMetaArray(editData).filter(item => item.dts && item.dts < this.timelineElement.$el.getCustomTime(1))
    //   if (filteredEvents && filteredEvents.length) {
    //     setActiveItem({ activeItem: filteredEvents[filteredEvents.length - 1] })
    //   }
    // }, 500)
  }

  onTimeChangeHandler () {
    this.isChangingCustomTime = true
  }

  onTimeChangedHandler () {
    const { playerElement } = this.props

    this.isChangingCustomTime = false
    playerElement.currentTime = this.timelineElement.$el.getCustomTime(1) / 1000
  }

  addTimelineCustomHandlers () {
    const { playerElement } = this.props

    this.timelineElement.$el.dom.bottom.addEventListener('click', (e) => {
      const rect = e.currentTarget.getBoundingClientRect()
      const offsetLeft = rect.left + document.body.scrollLeft

      playerElement.currentTime = this.timelineElement.$el.body.util.toTime(e.pageX - offsetLeft) / 1000
    })
  }

  onActivateScissors ({ event, item }) {
    if (!item) return false

    const { addItem, updateItem } = this.props
    const selectedItem = this.timelineElement.$el.itemsData.get(item)
    const rect = event.target.getBoundingClientRect()
    const offsetLeft = rect.left + document.body.scrollLeft
    const cut = this.timelineElement.$el.body.util.toTime((event.pointers[0].pageX - offsetLeft))
    const newItem = {
      id: v4(),
      start: cut,
      end: selectedItem.end,
      group: 1,
      type: 'range',
      editable: {
        updateTime: true,
        updateGroup: false,
        remove: true
      }
    }

    selectedItem.end = new Date(cut.valueOf() - 1)
    this.timelineElement.$el.itemsData.update([selectedItem, newItem])

    const newCutStartItem = this._createCutItem(v4(), newItem.start.getTime(), 'cut-start')
    const newCutStopItem = this._createCutItem(v4(), newItem.end.getTime(), 'cut-stop')
    const oldCutStartItem = this._createCutItem(selectedItem.cutStartId, selectedItem.start.getTime(), 'cut-start')
    const oldCutStopItem = this._createCutItem(selectedItem.cutStopId, selectedItem.end.getTime(), 'cut-stop')

    addItem({ metaItem: newCutStartItem })
    addItem({ metaItem: newCutStopItem })
    updateItem({ metaItem: oldCutStartItem })
    updateItem({ metaItem: oldCutStopItem })
  }

  onItemAdd (item, callback) {
    if (this._checkIntersect(item)) {
      callback(null)
      return false
    }

    item.id = v4()
    item.end = new Date(item.start.getTime() + 10000)
    item.type = 'range'
    item.content = ''

    const { addItem } = this.props
    const cutStartItem = this._createCutItem(v4(), item.start.getTime(), 'cut-start')
    const cutStopItem = this._createCutItem(v4(), item.end.getTime(), 'cut-stop')

    callback(item)
    addItem({ metaItem: cutStartItem })
    addItem({ metaItem: cutStopItem })
  }

  onItemMove (item, callback) {
    if (this._checkIntersect(item)) {
      callback(null)
      return false
    }

    const { updateItem, playerElement } = this.props

    if (item.start.getTime() >= 0 && item.end.getTime() <= playerElement.duration * 1000) {
      callback(item)

      const cutStartItem = this._createCutItem(item.cutStartId, item.start.getTime(), 'cut-start')
      const cutStopItem = this._createCutItem(item.cutStopId, item.end.getTime(), 'cut-stop')

      updateItem({ metaItem: cutStartItem })
      updateItem({ metaItem: cutStopItem })
    } else {
      callback(null)
    }
  }

  onItemRemove (item, callback) {
    const { removeItem } = this.props

    callback(item)
    removeItem({ id: item.cutStartId })
    removeItem({ id: item.cutStopId })
  }

  _createCutItem (id, dts, type) {
    return {
      id,
      dts,
      meta: { action: type }
    }
  }

  _checkIntersect (metaItem) {
    const cuts = this.timelineElement.$el.itemsData.get({ filter: (item) => item.group === 1 && item.id !== metaItem.id })
    let isIntersect = false

    for (let item of cuts) {
      if (
        metaItem.start.getTime() < item.end.getTime() &&
        metaItem.end.getTime() > item.start.getTime()
      ) {
        isIntersect = true
      }
    }

    return isIntersect
  }

  render () {
    const {
      isLoaded,
      isLoading,
      editData
    } = this.props
    const meta = isLoaded && metaToTimeline(editData)

    return (
      <Container fluid>
        { isLoading &&
          <Loader
            active
            inline='centered'
          />
        }
        { isLoaded &&
          <div className={css.timeline}>
            <Timeline
              ref={(timeline) => { this.timelineElement = timeline }}
              options={this.timelineOptions}
              groups={this.timelineGroups}
              items={meta}
              timechangeHandler={this.onTimeChangeHandler}
              timechangedHandler={this.onTimeChangedHandler}
              doubleClickHandler={this.onActivateScissors}
            />
          </div>
        }
      </Container>
    )
  }
}

const {
  bool,
  func,
  object
} = PropTypes

MediaTimeline.propTypes = {
  editData: object.isRequired,
  isLoaded: bool.isRequired,
  isLoading: bool.isRequired,
  playerElement: object,
  addItem: func.isRequired,
  updateItem: func.isRequired,
  removeItem: func.isRequired
}

export default MediaTimeline



// WEBPACK FOOTER //
// ./src/components/Timeline/Timeline.js